class TimelineComponent {
    constructor(){
        this.timelineDot = document.querySelector("#timeline-dot")
        if (!this.timelineDot) return  
        this.timelineItem = document.querySelectorAll(".timeline-item") 
        this.prevTimeline = document.querySelector("#prev-timeline")
        this.nextTimeline = document.querySelector("#next-timeline")
        this.currentTimeline = document.querySelector(".counter")
        this.countTimeline = document.querySelector(".total")
        this.selectedDot = ""
        this.addEvents()
    }

    addEvents(){
    this.timelineDot.addEventListener("click", (e) => {
        const dotItem = e.target.closest(".dot-item")
        if (!dotItem) return

        // this.selectedDot = dotItem.dataset.year
        this.selectedDot = dotItem.dataset.timeline

        // Remove active styles from all
        // this.timelineDot.querySelectorAll(".dot-item").forEach(item => {
        //     const dot = item.querySelector(".dot")
        //     const year = item.querySelector(".year")

        //     dot.classList.remove("bg-accent", "border-accent", "shadow-lg", "scale-125")
        //     dot.classList.add("bg-card", "border-border")

        //     year.classList.remove("text-accent")
        //     year.classList.add("text-muted-foreground")
        // })

        // // Add active styles to clicked one
        // const activeDot = dotItem.querySelector(".dot")
        // const activeYear = dotItem.querySelector(".year")

        // activeDot.classList.add("bg-accent", "border-accent", "shadow-lg", "scale-125")
        // activeDot.classList.remove("bg-card", "border-border")

        // activeYear.classList.add("text-accent")
        // activeYear.classList.remove("text-muted-foreground")

        
        this.SelectedDot(this.selectedDot)
        this.loadTabContent(this.selectedDot)
        this.arrowKeys(this.selectedDot)
    })

    this.nextTimeline.addEventListener("click", (e) => {
        let current = parseInt(e.currentTarget.dataset.current, 10)

        current++   // increment properly

        this.arrowKeys(current)

        this.loadTabContent(String(current))
        this.SelectedDot(String(current))
    })

    this.prevTimeline.addEventListener("click", (e) => {
        let current = parseInt(e.currentTarget.dataset.current, 10)
        
        current--   // increment properly

        this.arrowKeys(current)

        this.loadTabContent(String(current))
        this.SelectedDot(String(current))
    })
}
    loadTabContent(selectedValue){
    this.timelineItem.forEach(timeline => {
        const isActive = timeline.dataset.timeline === selectedValue

        // Hide/show
        timeline.classList.toggle("hidden", !isActive)

        // Add animation only to active one
        if (isActive) {
            timeline.classList.add("animate-fade-in-up")
        } else {
            timeline.classList.remove("animate-fade-in-up")
        }
    })
}

    SelectedDot(selectedValue){

    const selected = Number(selectedValue)

    this.timelineDot.querySelectorAll(".dot-item").forEach(item => {

        const current = Number(item.dataset.timeline)

        const dot = item.querySelector(".dot")
        const year = item.querySelector(".year")
        const underline = item.querySelector(".underline")

        // Reset underline first (important)
        if (underline) {
            underline.classList.remove("bg-accent", "bg-accent/50")
            underline.classList.add("bg-border")
        }

        if (current === selected) {
            // ACTIVE

            dot.classList.remove("bg-card", "border-border", "bg-accent/50", "border-accent/50")
            dot.classList.add("bg-accent", "border-accent", "shadow-lg", "scale-125")

            year.classList.remove("text-muted-foreground")
            year.classList.add("text-accent")

        } else if (current < selected) {
            // PAST ITEMS

            dot.classList.remove("bg-accent", "border-accent", "shadow-lg", "scale-125", "bg-card", "border-border")
            dot.classList.add("bg-accent/50", "border-accent/50")

            if (underline) {
                underline.classList.remove("bg-border")
                underline.classList.add("bg-accent/50")
            }

            year.classList.remove("text-accent")
            year.classList.add("text-muted-foreground")

        } else {
            // FUTURE ITEMS

            dot.classList.remove("bg-accent", "border-accent", "shadow-lg", "scale-125", "bg-accent/50", "border-accent/50")
            dot.classList.add("bg-card", "border-border")

            year.classList.remove("text-accent")
            year.classList.add("text-muted-foreground")
        }

    })
}

    arrowKeys(current){
        this.nextTimeline.dataset.current = current
        this.prevTimeline.dataset.current = current
        this.currentTimeline.innerHTML = current
        if(current > 1){
            this.prevTimeline.disabled = false
        }else{
            this.prevTimeline.disabled = true
        }
        if(current == this.countTimeline.innerHTML){
            this.nextTimeline.disabled = true
        }else{
            this.nextTimeline.disabled = false
        }
    }
}

export default TimelineComponent